import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoutFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11 19.392V19V7.503C11 6.813 10.645 6.172 10.06 5.807L6.06 3.307C4.728 2.475 3 3.432 3 5.003V16.891C3 17.581 3.355 18.222 3.94 18.587L7.94 21.087C9.272 21.92 11 20.962 11 19.392Z",
		fill: "#111827"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 11H21M21 11L19 13M21 11L19 9M11 19.392V7.503M11 19.392C11 20.962 9.272 21.92 7.94 21.087L3.94 18.587C3.355 18.222 3 17.581 3 16.891V5.003C3 3.432 4.728 2.475 6.06 3.307L10.06 5.807C10.645 6.172 11 6.813 11 7.503M11 19.392V19M11 7.503V19M11 19H15C16.105 19 17 18.105 17 17V16M17 6V5C17 3.895 16.105 3 15 3H5",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgLogoutFilled);
export default ForwardRef;
